$(document).ready(() => {

    $('#btn-favorite-expert').on('click', function () {
        $.ajax({
            url: $(this).data('url'),
            type: "post",
            dataType: "json",
            data: { expert_profile: $(this).data('expert')},
            statusCode:{
                200: (res) => $(this).toggleClass('favorited'),
                400: (res) => console.log(res.responseJSON.error)
            }
        })
    });

    let $videoModal = $('#videoModal');

    $videoModal
        .on('show.bs.modal', () => {
            let url = $('#video-modal').data('url');
            let titleVideo = $('#video-modal').data('video-title');
            let videoId = youtube_parser(url);
            let iframe = document.createElement('iframe');
            // / frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            iframe.src = "https://www.youtube.com/embed/" + videoId;
            iframe.width = "100%";
            iframe.height = "300";
            $('#videoModal .title').html(titleVideo);
            $('#videoModal .step-content').html(iframe);
        });

    $('.need-to-login').on('click', function () {
        $('#contact-expert-login').show();
    });
});

function youtube_parser(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
}